// extracted by mini-css-extract-plugin
module.exports = {"iList":"Socialicons_iList__2AQm_","icon":"Socialicons_icon__2KR0n"};